import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useTheme } from '../../hooks/useTheme';
import ColorGenerator from '../../components/shared/ColorGenerator';
import PublicPageHeader from '../../components/landing/PublicPageHeader';

/**
 * Public Color Generator - public screen for unauthenticated users.
 * Separate from authenticated ColorGeneratorScreen for security isolation.
 * Same implementation (1 try, blurred palettes, sign-up redirect).
 */
const PublicColorGeneratorScreen = () => {
  const { colors } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: colors.background }]}>
      <PublicPageHeader activeScreen="palette-generator" />
      <ColorGenerator hideUseMyPalette={true} isPublicPreview={true} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default PublicColorGeneratorScreen;
